var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection32Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 19.5,
    stroke: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4451 45.3333C49.2972 43.6665 49.7778 41.7782 49.7778 39.7777C49.7778 33.0276 44.3057 27.5555 37.5556 27.5555C30.8054 27.5555 25.3333 33.0276 25.3333 39.7777C25.3333 46.5279 30.8054 52 37.5556 52L52 52C52 52 49.7778 49.7777 48.4763 45.3981M47.2222 32C47.4408 30.9229 47.5556 29.8082 47.5556 28.6666C47.5556 19.4619 40.0936 12 30.8889 12C21.6841 12 14.2222 19.4619 14.2222 28.6666C14.2222 30.6146 14.5564 32.4845 15.1706 34.2222C17.5577 40.9149 12 45.3333 12 45.3333H26.4444",
    stroke: "#008DD2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection32Img);
export default __webpack_public_path__ + "static/media/section-3-2-img.bcc20e520b4e68f2b75237beb18e685e.svg";
export { ForwardRef as ReactComponent };